import { render, staticRenderFns } from "./MultiMenu.vue?vue&type=template&id=6ad22a86&scoped=true"
import script from "./MultiMenu.vue?vue&type=script&lang=js"
export * from "./MultiMenu.vue?vue&type=script&lang=js"
import style0 from "./MultiMenu.vue?vue&type=style&index=0&id=6ad22a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad22a86",
  null
  
)

export default component.exports